module.exports = __webpack_public_path__ + "static/media/om_beard_shortboxed_diamond__v_vector.409ed2b1.svg";